// Sibling-Umschalter im Kopf: "Anhang x von y" + vor/zurueck fuer weitere Dokumente derselben
// E-Mail (doc.siblings, s. BE-1 GET /documents/:id-Erweiterung). Nur sichtbar, wenn es mehr als
// einen Anhang gibt; onOpenDocument ist OPTIONAL (Absprache Welle 1/2) — ohne Prop degradiert der
// Umschalter auf reine Anzeige (keine toten Buttons).

import React from 'react';
import { ChevronLeft, ChevronRight, Paperclip } from 'lucide-react';
import { iconBtnCls } from '../ui';

const AbSiblingSwitcher = ({ isDarkMode, t, documentId, siblings, onOpenDocument }) => {
  const list = Array.isArray(siblings) ? siblings : [];
  if (list.length <= 1) return null;
  const idx = list.findIndex((s) => String(s.id) === String(documentId));
  const canNav = typeof onOpenDocument === 'function';
  const prev = idx > 0 ? list[idx - 1] : null;
  const next = idx >= 0 && idx < list.length - 1 ? list[idx + 1] : null;

  return (
    <div className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-lg ${isDarkMode ? 'bg-white/[0.06] text-white/60' : 'bg-slate-100 text-slate-500'}`}>
      <Paperclip className="w-3.5 h-3.5" />
      <span>{t('abPdf.attachmentOf', { n: idx >= 0 ? idx + 1 : '?', total: list.length })}</span>
      {canNav && (
        <>
          <button type="button" disabled={!prev} onClick={() => prev && onOpenDocument(prev.id)}
            title={t('abPdf.attachmentPrev')} className={iconBtnCls(isDarkMode)}>
            <ChevronLeft className="w-3.5 h-3.5" />
          </button>
          <button type="button" disabled={!next} onClick={() => next && onOpenDocument(next.id)}
            title={t('abPdf.attachmentNext')} className={iconBtnCls(isDarkMode)}>
            <ChevronRight className="w-3.5 h-3.5" />
          </button>
        </>
      )}
    </div>
  );
};

export default AbSiblingSwitcher;
